import Image from 'next/image'
import type { ImageProps } from 'next/image'
import tigoLogoTerracotta from 'public/images/logos/tigo/tigo-icon-terracotta .png'

export function Logo(props: Omit<ImageProps, 'src' | 'alt'>) {
  return <Image src={tigoLogoTerracotta} alt="Tigo Logo" {...props} />
}
